module.exports = __webpack_public_path__ + "img/kaoqin.8ce30800.png";